import {Nullish} from 'shared/web';

export type GetUserCredentialApiResponse = /** status 200  */ UserCredentialResponseBody;
export type IntegratedServiceType =
  | 'DAIMLER_CLARA'
  | 'MERCEDES_XENTRY_JOB'
  | 'SAG'
  | 'TECRMI'
  | 'DAIMLER_XENTRY_JOB'
  | 'MAZDA_PORTAL'
  | 'INTERCARS_CZ';
export type GetUserCredentialApiArg = {
  userId: string;
  integratedServiceType: IntegratedServiceType;
  authorizationProfileId?: string;
};
export type SetUserCredentialApiResponse = /** status 202  */ void;
export type SetUserCredentialApiArg = {
  userId: string;
  integratedServiceType: IntegratedServiceType;
  credentialRequestBody: CredentialRequestBody;
};
export type SetMyCredentialApiArg = {
  integratedServiceType: IntegratedServiceType;
  credentialRequestBody: CredentialRequestBody;
};
export type ListUserCredentialsApiResponse = /** status 200  */ ListUserCredentialsResponseBody;
export type ListUserCredentialsApiArg = {
  userId: string;
  params: object;
};

export type ListMyCredentialsApiArg = {
  params: object;
};
export type ListMyCredentialsApiResponse = /** status 200  */ ListUserCredentialsResponseBody;

export type CredentialParameterValueResponseBody = {
  name: string;
  value: string;
};
export type UserCredentialResponseBody = {
  id: string;
  userId: string;
  authorizationProfileId: string;
  enabled: boolean;
  createdAt: string;
  updatedAt: string | Nullish;
  integratedServiceCode: IntegratedServiceType;
  values: CredentialParameterValueResponseBody[];
};
export type CredentialParameterValueRequestBody = {
  name: string;
  value: string;
};
export type CredentialRequestBody = {
  authorizationProfileId: string;
  parameters: CredentialParameterValueRequestBody[];
};
export type ListUserCredentialsResponseBody = {
  credentials: UserCredentialResponseBody[];
};
